module.exports = __webpack_public_path__ + "images/hipages-primary-logo-reversed.svg";


//////////////////
// WEBPACK FOOTER
// ./footer/images/hipages-primary-logo-reversed.svg
// module id = 38
// module chunks = 1